import React, { useState } from 'react';
import { Accordion, Card, Col, Form } from 'react-bootstrap'; // Import Bootstrap components

const AccordionComp = () => {
  
  const [searchTerm, setSearchTerm] = useState(''); // State for search term

  const defaultAccordion = [
    { title: 'Accordion Item #1', text: 'This is the content for the first accordion item.' },
    { title: 'Accordion Item #2', text: 'This is the content for the second accordion item.' },
    { title: 'Accordion Item #3', text: 'This is the content for the third accordion item.' },
  ];

  // Filtered accordion items based on the search term
  const filteredAccordion = defaultAccordion.filter((item) =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.text.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Col xl="12" className='pt-4'>
      <Card className=''>
       
        <Card.Body className="card-body p-3">
          {/* Search Input */}
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="Search accordion items..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Form.Group>

          {/* Accordion */}
          <Accordion className="accordion accordion-primary" defaultActiveKey="0">
            {filteredAccordion.length > 0 ? (
              filteredAccordion.map((item, index) => (
                <Accordion.Item key={index} eventKey={`${index}`}>
                  <Accordion.Header className="accordion-header rounded-lg #3f3f3e"
                  style={{boxShadow: 'none'}}
                  
                  >
                    {item.title}
                  </Accordion.Header>
                  <Accordion.Collapse eventKey={`${index}`}>
                    <div className="accordion-body">{item.text}</div>
                  </Accordion.Collapse>
                </Accordion.Item>
              ))
            ) : (
              <p className="text-muted">No results found.</p>
            )}
          </Accordion>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default AccordionComp;
